// extracted by mini-css-extract-plugin
export default {"select":"ModalConfig_select__u4i7s","range":"ModalConfig_range__Si5n+","message_check":"ModalConfig_message_check__pR1HI"};